var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"full_wind relative",attrs:{"id":"log_in_wind"}},[_c('div',{staticClass:"ma"},[_c('Fatie')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }